export const cosneticsQueryKeys = {
  all: ['cosnetics'] as const,
  usersForProcessAll: ['cosnetics', 'users-for-process'] as const,
  usersForProcess: ({
    action,
    baseUrl,
    ProcessDefinitionId,
    ProcessInstanceId,
    UserDefinitionId
  }: {
    action: string;
    baseUrl: string;
    ProcessDefinitionId: number;
    ProcessInstanceId: number;
    UserDefinitionId: number;
  }) =>
    [
      ...cosneticsQueryKeys.all,
      'users-for-process',
      baseUrl,
      action,
      ProcessInstanceId,
      ProcessDefinitionId,
      UserDefinitionId
    ] as const,
  userDetail: (baseUrl: string, UserInstanceId: number) =>
    [
      ...cosneticsQueryKeys.all,
      'user-detail',
      baseUrl,
      UserInstanceId
    ] as const,
  relationshipsAll: ['cosnetics', 'relationships'] as const,
  relationships: ({
    action,
    AssignedUserDefinitionId,
    baseUrl,
    keyword,
    ProcessInstanceId,
    RelatedUserDefinitionId,
    UserDefinitionId,
    UserInstanceId
  }: {
    action: string;
    AssignedUserDefinitionId?: number;
    baseUrl: string;
    keyword?: string | null;
    ProcessInstanceId?: number;
    RelatedUserDefinitionId?: number;
    UserDefinitionId?: number;
    UserInstanceId?: number;
  }) =>
    [
      ...cosneticsQueryKeys.all,
      'relationships',
      baseUrl,
      action,
      UserInstanceId ?? null,
      UserDefinitionId ?? null,
      keyword ?? null,
      ProcessInstanceId ?? null,
      AssignedUserDefinitionId ?? null,
      RelatedUserDefinitionId ?? null
    ] as const
};
